import { createContext } from "react";

export const UserDataContext = createContext({
  userData: {},
  addUserData: (type) => {},
});
